// Where a signed-in user with no usable role lands.
//
// The app used to send anyone it couldn't place to the tester dashboard, so a
// missing or misspelt role read as "tester" and quietly handed over a working
// surface. Failing closed has to land somewhere, and it has to explain itself —
// a blank redirect loop is worse than a locked door with a sign on it.

import { ShieldAlert, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Button from "@/components/ui/Button";
import Logo from "@/components/common/Logo";

export default function NoAccess() {
  const { user, logout } = useAuth();

  return (
    <div className="grid min-h-screen place-items-center bg-slate-50 px-6 dark:bg-ink-950">
      <div className="w-full max-w-md text-center">
        <div className="mb-8 flex justify-center">
          <Logo />
        </div>

        <div className="card p-8">
          <span className="mx-auto mb-5 grid h-14 w-14 place-items-center rounded-2xl bg-amber-100 text-amber-600 dark:bg-amber-500/15 dark:text-amber-300">
            <ShieldAlert size={26} />
          </span>

          <h1 className="font-display text-xl font-semibold text-slate-900 dark:text-white">
            No workspace assigned
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-slate-500 dark:text-slate-400">
            Your account is signed in{user?.email ? ` as ${user.email}` : ""}, but it
            doesn&apos;t have a role that opens a dashboard yet. Ask an administrator
            or your project manager to set one up — you&apos;ll land here again until
            they do.
          </p>

          <Button variant="outline" className="mt-7 w-full" onClick={logout}>
            <LogOut size={16} /> Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
